import { getLogger } from 'amkit3-modules/utils/log4js'
import PlaybackEvent from 'amkit3-modules/v/playbacks/playback-event'
import HuyaUIEvent from 'amkit3-modules/v/ui/huya/huya-ui-event'
import UIEvent from 'amkit3-modules/v/ui/ui-event'
// import { strict } from 'assert';

const logger = getLogger('v/player/huya/plugins/ended-recommend')

const replaceAgreement = src => {
  const reg = /^(http|https):/i
  return src.replace(reg, '')
}

class EndedRecommendPlugin {
  constructor($, $container, options, playback, ui) {
    this.$ = $
    this.$container = $container
    this._options = options
    this._playback = playback
    this._ui = ui

    if (typeof global.vhuyaPlayerEndedRecommendData === 'object') {
      this._data = global.vhuyaPlayerEndedRecommendData
      /**
       * 去掉http协议
       */
      if (this._data.relateVideoList && this._data.relateVideoList.length) {
        this._data.relateVideoList = this._data.relateVideoList.map(item => this.format(item))
      }

      logger.info(
        'global.vhuyaPlayerEndedRecommendData',
        global.vhuyaPlayerEndedRecommendData,
        this._playback,
      )

      this._playback.on(PlaybackEvent.ENDED, () => {
        logger.debug('video is ended show Recommend Panel')
        this.show()
      })
      this._playback.on(PlaybackEvent.PLAYING, () => {
        logger.debug('video is playing hide Recommend Panel')
        this.hide()
      })
      this._ui.on(HuyaUIEvent.ENDED_RECOMMEND_REPLAY_BTN_CLICK, () => {
        logger.debug('HuyaUIEvent.ENDED_RECOMMEND_REPLAY_BTN_CLICK')
        this._ui.emit(UIEvent.REPLAY_BUTTON_CLICK)
        this._ui.setPause()
        this.hide()
      })
      this._ui.on(HuyaUIEvent.ENDED_RECOMMEND_COMMENT_BTN_CLICK, () => {
        global.location.hash = 'comment'
        // 添加hashchange监听，确保滚动后能重新定位
        const handleHashChange = () => {
          if (global.location.hash === '#comment') {
            const commentEl = document.getElementById('comment')
            if (commentEl) {
              commentEl.scrollIntoView({ behavior: 'smooth' })
            }
          }
        }
        window.addEventListener('hashchange', handleHashChange)
        // 立即触发一次定位
        handleHashChange()
      })
      this._ui.on(HuyaUIEvent.ENDED_RECOMMEND_SUBSCRIBE_BTN_CLICK, () => {
        if (typeof global.huya_subscribe_module === 'object') {
          global.huya_subscribe_module.isSubscribe(this._data.liveInfo.uid, (_, result) => {
            if (result) {
              global.huya_subscribe_module.unsubscribe(this._data.liveInfo.uid, () => {
                global.huya_subscribe_module.render()
                this.renderUnsubscribe()
              })
            } else {
              global.huya_subscribe_module.subscribe(this._data.liveInfo.uid, () => {
                global.huya_subscribe_module.render()
                this.renderSubscribe()
              })
            }
          })
        }
      })

      logger.debug('data', this._data, 'is valid, add a ENDED handler')
    } else {
      logger.debug('global.vhuyaPlayerEndedRecommendData is not available')
    }
  }
  show() {
    logger.warn('ui.showEndedRecommend')
    if (typeof this._ui.showEndedRecommend === 'function') {
      this._ui.showEndedRecommend(this._data)
      // TODO
      this.$container.find('video').css('filter', 'blur(8px)')

      this._playback.once(PlaybackEvent.PLAYING, () => this.hide())
    } else {
      logger.warn('ui.showEndedRecommend is not available')
    }
  }

  format(item) {
    item.user_avatar = replaceAgreement(item.user_avatar)
    item.user_homepage = replaceAgreement(item.user_homepage)
    item.video_big_cover = replaceAgreement(item.video_big_cover)
    item.video_cover = replaceAgreement(item.video_cover)
    item.video_url = replaceAgreement(item.video_url)
    return item
  }

  hide() {
    this._ui.hideEndedRecommend()
    this.$container.find('video').css('filter', 'none')
    logger.warn('ui.hideEndedRecommend is close')
  }
  renderSubscribe() {
    this._ui.setEndedRecommendSubscribed()
  }
  renderUnsubscribe() {
    this._ui.setEndedRecommendUnsubscribe()
  }
}

export default EndedRecommendPlugin
